import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AchievementComponent } from './pages/achievement/achievement.component';
import { AchievementEditComponent } from './pages/achievement/edit/achievement-edit.component';
import { DashboardComponent } from './pages/admin/dashboard/dashboard.component';
import { DashboardAccessControlComponent } from './pages/admin/dashboard-access-control/dashboard-access-control.component';
import { EventsComponent } from './pages/admin/events/events.component';
import { LicenceComponent } from './pages/admin/licence/licence.component';
import { RegisteredUsersComponent } from './pages/admin/registered-users/registered-users.component';
import { RolesComponent } from './pages/admin/roles/roles.component';
import { ShopifyComponent } from './pages/admin/shopify/shopify.component';
import { WhitelistComponent } from './pages/admin/whitelist/whitelist.component';
import { ReportsComponent } from './pages/admin/reports/reports.component';
import { AuditUserEventsComponent } from './pages/audit-user-events/audit-user-events.component';
import { ChatComponent } from './pages/chat/chat.component';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { HomeComponent } from './pages/home/home.component';
import { JourneyEditComponent } from './pages/journey/edit/journey-edit.component';
import { JourneyComponent } from './pages/journey/journey.component';
import { LoginComponent } from './pages/login/login.component';
import { PermissionComponent } from './pages/permission/permission.component';
import { SurveyEditComponent } from './pages/survey/edit/edit.component';
import { SurveyResultComponent } from './pages/survey/result/result.component';
import { SurveyComponent } from './pages/survey/survey.component';
import { VimeoComponent } from './pages/vimeo/vimeo.component';
import { ReviewComponent } from './pages/review/review.component';
import { CmsService } from './services/cms.service';
import { NodeEditorService } from './services/node-editor.service';
import { VRSpeechComponent } from './pages/admin/vrspeech/vrspeech.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },

  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'login/:returnTo',
        component: LoginComponent
      }
    ]
  },

  {
    path: '',
    component: AdminComponent,
    canActivate: [CmsService],
    canActivateChild: [NodeEditorService],
    children: [
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'vimeo',
        component: VimeoComponent
      },
      {
        path: 'vimeo/auth',
        component: VimeoComponent,
        data: {
          auth: true
        }
      },
      {
        path: 'review',
        component: ReviewComponent
      },
      {
        path: 'audit/users',
        component: AuditUserEventsComponent
      },
      {
        path: 'permission',
        component: PermissionComponent
      },
      {
        path: 'achievement',
        component: AchievementComponent
      },
      {
        path: 'achievement/:uuid',
        component: AchievementEditComponent
      },
      {
        path: 'journey',
        component: JourneyComponent
      },
      {
        path: 'journey/:uuid',
        component: JourneyEditComponent
      },
      {
        path: 'configuration',
        component: ConfigurationComponent
      },
      {
        path: 'survey',
        component: SurveyComponent
      },
      {
        path: 'survey/:uuid',
        component: SurveyEditComponent
      },
      {
        path: 'survey/:uuid/results',
        component: SurveyResultComponent
      },
      {
        path: 'chat',
        component: ChatComponent
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'access_control',
        component: DashboardAccessControlComponent
      },
      {
        path: 'users',
        component: RegisteredUsersComponent
      },
      {
        path: 'whitelist',
        component: WhitelistComponent
      },
      {
        path: 'licence',
        component: LicenceComponent
      },
      {
        path: 'roles',
        component: RolesComponent
      },
      {
        path: 'shopify',
        component: ShopifyComponent
      },
      {
        path: 'vrspeech',
        component: VRSpeechComponent
      },
      {
        path: 'events',
        component: EventsComponent
      },
      {
        path: 'reports',
        component: ReportsComponent
      },
      {
        path: 'node',
        loadChildren: () => import('./pages/node/node.module').then(m => m.NodeModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      paramsInheritanceStrategy: 'always'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
